import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	assignToMe: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	assignToMe: {
		id: 'issue-create-commons.assignee-field.assign-to-me',
		defaultMessage: 'Assign to me',
		description: 'Assign to me button label for assignee field',
	},
});
export default messages;
